var escape = require("../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#app[data-v-7ba5bd90]{\n  /* background: url(./assets/image/bg2.png) no-repeat center bottom/100%,  */\n  background: url(" + escape(require("./assets/image/bg.png")) + ") no-repeat center top/100%, #020202;\n  min-height: 100vh;\n  font-family: Roboto-Regular,DMSans-Regular;\n  position: relative;\n  max-width: 100vw;\n  overflow: hidden;\n}\n#app .img[data-v-7ba5bd90]{\n  width: 100%;\n  position: absolute;\n  left: 0;\n  top:0;\n  z-index: -10;\n}\n#app[data-v-7ba5bd90] .el-backtop{\n  color: #2675F1;\n  z-index: 100;\n}\n\n", ""]);

// exports
